import { LocalizedText, UseDialogActionReturn } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Button, Dialog } from '@optimus-web/core';

interface UnassignPropertiesDialogProps {
    unassignPropertyAction: UseDialogActionReturn;
    active: boolean;
    titleTextKey: Mews.TextKey;
    descriptionTextKey: Mews.TextKey;
}

export const UnassignPropertiesDialog = ({
    unassignPropertyAction,
    active,
    titleTextKey,
    descriptionTextKey,
}: UnassignPropertiesDialogProps) => (
    <Dialog
        title={<LocalizedText textKey={titleTextKey} />}
        active={active}
        size="small"
        footerDetail={
            <Button variant="tertiary" onClick={unassignPropertyAction.handlers.handleCancel} type="submit">
                <LocalizedText textKey={TextKey.Cancel} />
            </Button>
        }
        loading={unassignPropertyAction.states.isProcessing}
        onClose={unassignPropertyAction.handlers.handleCancel}
        actions={[
            {
                children: <LocalizedText textKey={TextKey.Remove} />,
                onClick: unassignPropertyAction.handlers.handleConfirm,
                variant: 'primary',
                type: 'submit',
            },
        ]}
    >
        <LocalizedText textKey={descriptionTextKey} />
    </Dialog>
);
